import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { Routes_path } from "../routerApp";

const COOKIE_NAME = "technicalCookie";
const COOKIE_DAYS = 30;

const readCookie = (name: string): string | null => {
	const escaped = name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&");
	const match = document.cookie.match(
		new RegExp("(?:^|; )" + escaped + "=([^;]*)")
	);
	return match ? decodeURIComponent(match[1]) : null;
};

const writeCookie = (name: string, value: string, days: number) => {
	const expires = new Date(Date.now() + days * 864e5).toUTCString();
	document.cookie = `${name}=${encodeURIComponent(
		value
	)}; expires=${expires}; path=/; SameSite=Lax`;
};

const CookieBanner = () => {
	const [accepted, setAccepted] = useState(true);

	useEffect(() => {
		setAccepted(readCookie(COOKIE_NAME) === "true");
	}, []);

	if (accepted) return null;

	const handleAccept = () => {
		writeCookie(COOKIE_NAME, "true", COOKIE_DAYS);
		setAccepted(true);
	};

	return (
		<Box
			sx={{
				position: "fixed",
				bottom: 0,
				left: 0,
				right: 0,
				bgcolor: "rgba(53, 53, 53, 0.95)",
				color: "white",
				p: 2,
				zIndex: (t) => t.zIndex.snackbar,
			}}
		>
			<Stack
				direction={{ xs: "column", md: "row" }}
				spacing={2}
				sx={{ alignItems: "center" }}
			>
				<Typography variant="body2" sx={{ flexGrow: 1 }}>
					Il sito di Macello Scarso NON utilizza alcun cookie di profilazione,
					ma si avvale di cookie di tipo tecnico e di tipo analitico per
					informazioni aggregate ed anonime con finalità statistiche. Se vuoi
					saperne di più leggi&nbsp;
					<Link to={Routes_path.COOKIES} style={{ color: "#ffd42d" }}>
						la nostra informativa sull'uso dei cookie
					</Link>
					.
				</Typography>
				<Button
					onClick={handleAccept}
					sx={{
						bgcolor: "#ffd42d",
						color: "#000",
						"&:hover": { bgcolor: "#e6bf00" },
					}}
				>
					Ok, ho capito.
				</Button>
			</Stack>
		</Box>
	);
};

export default CookieBanner;
